export default {
    setWorkspaceFeeders(state, payload) {
        state.workspaceFeeders = payload;
    }
}